import { render, staticRenderFns } from "./TriggerIcon.vue?vue&type=template&id=f8e74720&"
import script from "./TriggerIcon.vue?vue&type=script&lang=ts&"
export * from "./TriggerIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TriggerIcon.vue?vue&type=style&index=0&id=f8e74720&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports